import { render, staticRenderFns } from "./AlbumContent.vue?vue&type=template&id=efb7abcc&scoped=true"
import script from "./AlbumContent.vue?vue&type=script&lang=js"
export * from "./AlbumContent.vue?vue&type=script&lang=js"
import style0 from "./AlbumContent.vue?vue&type=style&index=0&id=efb7abcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb7abcc",
  null
  
)

export default component.exports